import styled from "styled-components";
import distances from "styles/distances.js";
import mediaQuery from "styles/mediaQuery";

const MainWrapper = styled.div`
  padding: 0 ${distances.pageMarginBig}rem;
  width: calc(100% - ${distances.pageMarginBig * 2}rem);
  position: relative;
  height: 100%;

  @media (max-width: ${mediaQuery.tablet}) {
    padding: 0 ${distances.pageMarginSmall}rem;
    width: calc(100% - ${distances.pageMarginSmall * 2}rem);
  }
`;

export default MainWrapper;
